import styled from '@emotion/styled'

const S = {}

S.Slide = styled.div`
  color: white;
`

export default S
